/**
 * @returns true if price is 0.
 */
export const isFreePlan = plan => plan.pricing?.price?.value === '0';
//# sourceMappingURL=is-free-plan.js.map